import { CircularProgress } from '@material-ui/core';
import App from '../App';

export const LoadingButton = ({ children, loading, className='' } : {children: any, loading:boolean, className?: string}) => {
  const color = App.getPropertyFromStyle('--card-buttons-font-color')
  return (
    <div className={`${loading ? 'loading-btn loading' : 'loading-btn'} ${className}`}>
      {children}
      {loading && <CircularProgress size={22} className="circular-progress" style={{color:color}}/>}
    </div>
  )
};